<template>
  <div>
    <div class="fake-header" style="height: 80px;width: 100%; background: #218BEF"></div>
    <div class="dwbanner"></div>
    <div class="content">
      <div class="tab-one">
        <div class="tab-item">
          <div class="tab-item-img">
            <img src="../../static/img/index/person.png" alt="">
          </div>
          <div class="tab-item-text">
            个人事项
          </div>
          <div class="active-line">
            <div class="triangle"></div>
          </div>
        </div>
        <div class="tab-item active">
          <div class="tab-item-img">
            <img src="../../static/img/index/legal.png" alt="">
          </div>
          <div class="tab-item-text">
            法人事项
          </div>
          <div class="active-line">
            <div class="triangle"></div>
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="one-cont">
        <div class="cont1" style="display: none;">
          <div class="swiper-button-next swiper-button-next2" style="right: 264px; margin-top: 54px"></div>
          <div class="swiper-button-prev swiper-button-prev2" style="left: 264px; margin-top: 54px"></div>
          <div class="swiper tab-swiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="tab-two">
                  <div class="tab-item active">
                    <div class="icon">
                      <img src="../../static/img/index/fr-icon2.png">
                    </div>
                    <p>出生</p>
                  </div>
                  <div class="tab-item">
                    <img src="../../static/img/index/fr-icon5.png">
                    <p>学习</p>
                  </div>
                  <div class="tab-item">
                    <div class="icon">
                      <img src="../../static/img/index/fr-icon3.png">
                    </div>
                    <p>工作</p>
                  </div>
                  <div class="tab-item">
                    <div class="icon">
                      <img src="../../static/img/index/fr-icon4.png">
                    </div>
                    <p>购房</p>
                  </div>
                  <div class="tab-item">
                    <div class="icon">
                      <img src="../../static/img/index/fr-icon6.png">
                    </div>
                    <p>婚姻</p>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="tab-two">
                  <div class="tab-item">
                    <div class="icon">
                      <img src="../../static/img/index/fr-icon2.png">
                    </div>
                    <p>婚育</p>
                  </div>
                  <div class="tab-item">
                    <img src="../../static/img/index/fr-icon5.png">
                    <p>迁居</p>
                  </div>
                  <div class="tab-item">
                    <div class="icon">
                      <img src="../../static/img/index/fr-icon3.png">
                    </div>
                    <p>退休</p>
                  </div>
                  <div class="tab-item">
                    <div class="icon">
                      <img src="../../static/img/index/fr-icon4.png">
                    </div>
                    <p>身后事</p>
                  </div>
                  <div class="tab-item-e">
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination swiper-pagination2"></div>
          </div>
          <div class="two-cont">
            <div class="cont">
              <div class="dwPart" id="part1">
                <ul class="partul flex-4">
                  <li><img src="../../static/img/duowei/itemiconactive.png">
                    <a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/11440106007508683Q444210610900101">
                      事项名称：国（境）内出生登记
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="cont" style="display: none;">
              <div class="dwPart" id="part1">
                <ul class="partul flex-4">
                  <li><img src="../../static/img/duowei/itemiconactive.png">
                    <a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/11440106MB2C79403T4440705001000">
                      少数民族高考考生资格确认
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="cont" style="display: none;">
              <div class="dwPart" id="part1">
                <ul class="partul flex-4">
                  <li><img src="../../static/img/duowei/itemiconactive.png">
                    <a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/1144010600750851XC4442111180001">
                      创业担保贷款申请
                    </a>
                  </li>
                  <li><img src="../../static/img/duowei/itemiconactive.png">
                    <a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/1144010600750851XC4442111689000">
                      失业保险金申领
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="cont" style="display: none;">
              <div class="dwPart" id="part1">
                <ul class="partul flex-4">
                  <li><img src="../../static/img/duowei/itemiconactive.png">
                    <a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/11440106MB2C4883494442112006000">
                      不动产登记资料查询
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="cont" style="display: none;">
              <div class="dwPart" id="part1">
                <ul class="partul flex-4">
                  <li><img src="../../static/img/duowei/itemiconactive.png">
                    <a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/11440106007508675X4440708003001">
                      内地居民结婚登记
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="cont" style="display: none;">
              <div class="dwPart" id="part1">
                <ul class="partul flex-4">
                  <li><img src="../../static/img/duowei/itemiconactive.png">
                    <a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/1144010674595773915442020021001">
                      生育登记
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="cont" style="display: none;">
              <div class="dwPart" id="part1">
                <ul class="partul flex-4">
                  <li><img src="../../static/img/duowei/itemiconactive.png">
                    <a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/11440106007508683Q444210610001001">
                      市外迁入-人才引进
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="cont" style="display: none;">
              <div class="dwPart" id="part1">
                <ul class="partul flex-4">
                  <li><img src="../../static/img/duowei/itemiconactive.png">
                    <a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/1144010600750851XC4442111530001">
                      用人单位退休人员移交社会服务管理
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="cont" style="display: none;">
              <div class="dwPart" id="part1">
                <ul class="partul flex-4">
                  <li><img src="../../static/img/duowei/itemiconactive.png">
                    <a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/11440106007508683Q4442106093001">
                      凭《居民死亡医学证明（推断）书》
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="cont1">
          <div class="tab-two">
            <div class="tab-item">
              <div class="icon">
                <img src="../../static/img/index/fr-icon2.png">
              </div>
              <p>企业开办</p>
            </div>
            <div class="tab-item">
              <div class="icon">
                <img src="../../static/img/index/fr-icon3.png">
              </div>
              <p>用工招聘</p>
            </div>
            <div class="tab-item">
              <div class="icon">
                <img src="../../static/img/index/fr-icon4.png">
              </div>
              <p>缴费纳税</p>
            </div>
            <div class="tab-item active">
              <img src="../../static/img/index/fr-icon5.png">
              <p>生产经营</p>
            </div>
            <div class="tab-item">
              <div class="icon">
                <img src="../../static/img/index/fr-icon6.png">
              </div>
              <p>破产注销</p>
            </div>
          </div>
          <div class="two-cont1">
            <div class="cont" style="display: none;">
              <div class="dwPart" id="part1">
                <ul class="partul flex-4">
                  <li><img src="../../static/img/duowei/itemiconactive.png">
                    <a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/1144010607844173874440125017023">
                      合伙企业设立登记
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="cont" style="display: none;">
              <div class="dwPart" id="part1">
                <ul class="partul flex-4">
                  <li><img src="../../static/img/duowei/itemiconactive.png">
                    <a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/1144010674595773915442111836001">
                      就业登记
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="cont" style="display: none;">
              <div class="dwPart" id="part1">
                <ul class="partul flex-4">
                  <li><img src="../../static/img/duowei/itemiconactive.png">
                    <a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/11440106MB2D03995P4442024018000">
                      增值税一般纳税人登记
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="cont">
              <div class="dwPart" id="part1">
                <div class="conTitle">住宿和餐饮业</div>
                <ul class="partul flex-4">
                  <li class="active"><img src="../../static/img/duowei/itemiconactive.png"><a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/11440106MB2C8363X64440125009005">食品经营许可证核发（实施申请人承诺制的小餐饮）</a></li>
                </ul>
              </div>
              <div class="dwPart" id="part2">
                <div class="conTitle">居民服务业</div>
                <ul class="partul flex-4">
                  <li><img src="../../static/img/duowei/itemiconactive.png">
                    <a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/11440106007508640B4440120017001">公共场所卫生许可（新证，含改、扩建)
                    </a>
                  </li>
                </ul>
              </div>
              <div class="dwPart" id="part3">
                <div class="conTitle">药品零售</div>
                <ul class="partul flex-4">
                  <li><img src="../../static/img/duowei/itemiconactive.png">
                    <a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/11440106MB2C8363X6444017201100702">
                      药品经营许可证核准（零售）
                    </a>
                  </li>
                  <li><img src="../../static/img/duowei/itemiconactive.png">
                  <a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/11440106007508640B4440120003002">
                    医疗机构执业许可（执业登记）
                  </a>
                  </li>
                </ul>
              </div>
              <div class="dwPart" id="part4">
                <div class="conTitle">文体旅游业</div>
                <ul class="partul flex-4">
                  <li><img src="../../static/img/duowei/itemiconactive.png">
                    <a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/11440106007508624M4440119017003">
                      娱乐场所从事娱乐场所经营活动审批
                    </a>
                  </li>
                </ul>
              </div>
              <div class="dwPart" id="part5">
                <div class="conTitle">商务服务业</div>
                <ul class="partul flex-4">
                  <li><img src="../../static/img/duowei/itemiconactive.png">
                    <a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/11440100MB2D34863G444017802200201">
                      公众聚集场所投入使用、营业前消防安全检查（告知承诺件)
                    </a>
                  </li>
                </ul>
              </div>
              <div class="dwPart" id="part6">
                <div class="conTitle">制造业</div>
                <ul class="partul flex-4">
                  <li><img src="../../static/img/duowei/itemiconactive.png">
                    <a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/11440106007508683Q4440106032000">
                      印章刻制业许可证核发
                    </a>
                  </li>
                </ul>
              </div>
              <div class="dwPart" id="part7">
                <div class="conTitle">医护保健业</div>
                <ul class="partul flex-4">
                  <li><img src="../../static/img/duowei/itemiconactive.png">
                    <a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/11440106734892300B444011704600001">
                      动物诊疗许可证核发
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="cont" style="display: none;">
              <div class="dwPart" id="part1">
                <ul class="partul flex-4">
                  <li><img src="../../static/img/duowei/itemiconactive.png">
                    <a target="_blank" href="https://www.gdzwfw.gov.cn/portal/v2/guide/114401060784417387444012501705101">
                      合伙企业注销登记
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!--  左侧导航栏-->
<!--    <div class="Leftnav">-->
<!--      <ul>-->
<!--        <li :class="[isInArea1 ? 'Lactive' : '']" @click="scrollToArea(1)"><a>社会保障</a></li>-->
<!--        <li :class="[isInArea2 ? 'Lactive' : '']" @click="scrollToArea(2)"><a>住房保障</a></li>-->
<!--        <li :class="[isInArea3 ? 'Lactive' : '']" @click="scrollToArea(3)"><a>户证档案</a></li>-->
<!--        <li :class="[isInArea4 ? 'Lactive' : '']" @click="scrollToArea(4)"><a>交通运输</a></li>-->
<!--        <li :class="[isInArea5 ? 'Lactive' : '']" @click="scrollToArea(5)"><a>执业资格</a></li>-->
<!--        <li :class="[isInArea6 ? 'Lactive' : '']" @click="scrollToArea(6)"><a>就业创业</a></li>-->
<!--        <li :class="[isInArea7 ? 'Lactive' : '']" @click="scrollToArea(7)"><a>婚育服务</a></li>-->
<!--        <li :class="[isInArea8 ? 'Lactive' : '']" @click="scrollToArea(8)"><a>养老助残</a></li>-->
<!--      </ul>-->
<!--    </div>-->
  </div>
</template>

<script src="../../static/js/jquery.min.js"></script>
<script src="../../static/js/index.js"></script>
<script>
export default {
  name: "Multiple",
  data() {
    return {
      isInArea1: true,
      isInArea2: false,
      isInArea3: false,
      isInArea4: false,
      isInArea5: false,
      isInArea6: false,
      isInArea7: false,
      isInArea8: false,
      searchKey: "",
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll)
  },
  methods: {

    scrollToArea(index) {
      var scale = document.documentElement.clientWidth / 1920; // 分母——设计稿的尺寸
      var e1 = document.getElementById('part1').offsetTop * scale;
      var e2 = document.getElementById('part2').offsetTop * scale;
      var e3 = document.getElementById('part3').offsetTop * scale;
      var e4 = document.getElementById('part4').offsetTop * scale;
      var e5 = document.getElementById('part5').offsetTop * scale;
      var e6 = document.getElementById('part6').offsetTop * scale;
      var e7 = document.getElementById('part7').offsetTop * scale;
      var e8 = document.getElementById('part8').offsetTop * scale;
      console.log(e1);
      console.log(e2);
      console.log(e3);
      console.log(e4);
      console.log(e5);
      console.log("///////////");

      var scrollY =
        index == 1 ? e1 :
          index == 2 ? e2 :
            index == 3 ? e3 :
              index == 4 ? e4 :
                index == 5 ? e5 :
                  index == 6 ? e6 :
                    index == 7 ? e7 :
                      index == 8 ? e8 :
                  0
      var options = {
        "top": scrollY,
        "left": 0,
        "behavior": "smooth"
      }

      window.scrollTo(options);
    },

    handleScroll() {
      const scrollTop = this.getScroll().top;
      //console.log(scrollTop)
      this.isInArea1 = false;
      this.isInArea2 = false;
      this.isInArea3 = false;
      this.isInArea4 = false;
      this.isInArea5 = false;
      this.isInArea6 = false;
      this.isInArea7 = false;
      this.isInArea8 = false;
      var scale = document.documentElement.clientWidth / 1920; // 分母——设计稿的尺寸
      var e1 = document.getElementById('part1').offsetTop * scale;
      var e2 = document.getElementById('part2').offsetTop * scale;
      var e3 = document.getElementById('part3').offsetTop * scale;
      var e4 = document.getElementById('part4').offsetTop * scale;
      var e5 = document.getElementById('part5').offsetTop * scale;
      var e6 = document.getElementById('part6').offsetTop * scale;
      var e7 = document.getElementById('part7').offsetTop * scale;
      var e8 = document.getElementById('part8').offsetTop * scale;
      if (scrollTop < e2 - 10) {
        this.isInArea1 = true;
      } else if (scrollTop < e3 - 10) {
        this.isInArea2 = true;
      } else if (scrollTop < e4 - 10) {
        this.isInArea3 = true;
      } else if (scrollTop < e5 - 10) {
        this.isInArea4 = true;
      } else if (scrollTop < e6 - 10) {
        this.isInArea5 = true;
      } else if (scrollTop < e7 - 10) {
        this.isInArea6 = true;
      } else if (scrollTop < e8 - 250) {
        this.isInArea7 = true;
      }else {
        this.isInArea8 = true;
      }
    },

    //获得页面向左、向上卷动的距离
    getScroll() {
      return {
        left: window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0,
        top: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      };
    },
  }
}
</script>

<style>
@import "../../static/css/bootstrap.min.css";
@import "../../static/css/common.css";
@import "../../static/css/base.css";
@import "../../static/css/global.css";
@import '../../static/css/duowei.css';
@import '../../static/css/newduowei.css';
</style>



// WEBPACK FOOTER //
// Multiple.vue?65e27be4